import React from 'react';

export const ScreenShareOnIcon = (props) => {
  const { className = '', style = {}, disabled = false, onClick } = props;
  return (
    <svg
      className={`custom-icon ${disabled ? 'disabled' : ''} ${className}`}
      onClick={disabled ? null : onClick}
      style={style}
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6541 17.9602C13.0307 18.3303 13.6329 18.3283 14.007 17.9542L18.8725 13.0887V15.6124C18.8725 16.1342 19.2851 16.5588 19.8068 16.571C20.3407 16.5831 20.7896 16.1463 20.7896 15.6124V9.82477H15.0019C14.4559 9.82477 14.0313 10.2737 14.0434 10.8076C14.0555 11.3293 14.4802 11.7419 15.0019 11.7419H17.5257L12.6602 16.6074C12.2861 16.9815 12.2841 17.5836 12.6541 17.9602Z"
        fill="#D9ECFA"
      />
      <path d="M12.6541 17.9602L12.6601 17.9662L12.6481 17.9542L12.6541 17.9602Z" fill="#D9ECFA" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M28.6521 6.5002V21.8854C28.6521 22.2737 28.3366 22.577 27.9605 22.577H5.34371C4.95544 22.577 4.6521 22.2616 4.6521 21.8854V6.5002C4.6521 6.11193 4.96757 5.80859 5.34371 5.80859H27.9484C28.3366 5.80859 28.64 6.12406 28.64 6.5002H28.6521ZM27.0869 7.37381H6.21732V21.0361H27.0869V7.37381Z"
        fill="#D9ECFA"
      />
      <path
        d="M10.9854 23.8086C10.4331 23.8086 9.98543 24.2563 9.98543 24.8086C9.98543 25.3609 10.4331 25.8086 10.9854 25.8086H22.3188C22.8711 25.8086 23.3188 25.3609 23.3188 24.8086C23.3188 24.2563 22.8711 23.8086 22.3188 23.8086H10.9854Z"
        fill="#D9ECFA"
      />
    </svg>
  );
};
